import { createStore, applyMiddleware, compose } from "redux";
import reduxThunk from "redux-thunk";
import reducers from "./reducers";

const composeEnhancers = ((typeof window !== 'undefined') && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
export default createStore(reducers, /* preloadedState, */ composeEnhancers(
  applyMiddleware(reduxThunk)
));



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/redux/store.js